import { types, getParent,getRoot, flow } from 'mobx-state-tree';
import PolicySet from './PolicySet';
import { PolicySetOptions, ShippingMethods } from '../../../models/BusinessPolicy';

const Policies = types
  .model('Policies', {
    policyList: types.optional(types.array(PolicySet), []),
    policySetOptions: types.optional(PolicySetOptions, {}),
    selectedPolicySetCode: types.maybe(types.string),
    shippingMethods: types.optional(ShippingMethods, {}),
    selectedDestId: types.optional(types.string, ''),
    isOptedIn:types.optional(types.boolean,true),
  })
  .views(self => ({
    get transport5007() {
      return getParent(self).transport5007;
    },
    get defaultPolicy() {
      return self.policyList.find(policy => policy.isDefault === true);
    },
    get selectedPolicySet() {
      if (self.selectedPolicySetCode) {
        return self.policyList.find(policy => policy.code === self.selectedPolicySetCode);
      }
      return self.policyList.find(policy => policy.isNew);
    },
    get noPolicyLoaded() {
      return self.policyList.length === 0;
    },
  }))
  .actions(self => ({
    resetPolicyList() {
      self.policyList = [];
    },
    setSelectedPolicySetCode(code) {
      self.selectedPolicySetCode = code;
    },
    setSelectedDestId(value) {
      self.selectedDestId = value;
    },
    deletePolicy: code => {
      try {
        self.policyList = self.policyList.filter(policy => policy.code !== code);
      } catch (err) {
        console.log('deleting failed: ', err);
      }
    },
    fetchPolicyData: flow(function* fetchPolicyData(...args) {
      yield Promise.allSettled([self.fetchPolicySets(...args), self.shippingMethods.fetchData()]);
    }),
    fetchPolicySets: flow(function* fetchPolicySets(src, account) {
      try {
        const url = 'business-policy/v1/business-policy-sets';
        const params = {
          sourceMarketplaceId: src || getParent(self).markets.defaultSource.id,
        };
        const { data } = yield self.transport5007.fetch(url, params, {
          'Seller-Account-Id': account || getParent(self).markets.defaultSellersAccount.id,
        });
        if (self.policyList.find(p => p.isNew)) {
          self.policyList = [...data, ...self.policyList];
        } else {
          self.policyList = data;
        }
      } catch (err) {
        self.policyList = [];
        console.log('err: ', err);
      }
    }),
    fetchPolicyFormOptions: flow(function* fetchPolicyFormOptions(account) {
      try {
        const { sellerAccountCode } = getParent(self).listing;
        const url = 'business-policy/v1/business-policy-sets/seller-business-policies';
        const { data } = yield self.transport5007.fetch(
          url,
          { DestinationMarketplaceId: getParent(self).markets.defaultDestination.id },
          {
            'Seller-Account-Id': account || sellerAccountCode,
          },
        );
        self.policySetOptions = data;
      } catch (err) {
        console.log(err);
      }
    }),
    fetchUserOptedIn: flow(function* fetchShippingPolicyData(selectedDestId) {
      try {
        const url = `ebay-api/v1/payment-policies/check-user-opted-in?DestinationMarketplaceId=${selectedDestId}`;
        const headers = {
          "Account-Id":getRoot(self).uiStore.sessionStore.accountCode,
          "Seller-Account-Id": getParent(self).markets.defaultSellersAccount.id,
        };
        const { data } = yield self.transport5007.fetch(url,{},headers);
        self.isOptedIn=data;
        return true;
      } catch (err) {
        self.isOptedIn=false;
        console.log(err);
        return false;
      }
    }),
    addNewPolicy(policy = PolicySet.create({ isNew: true })) {
      self.policyList.push(policy);
    },
    toggleDefaultPolicy() {
      const currentDefaultPolicy = self.policyList.find(policy => policy.isDefault);
      if (currentDefaultPolicy) {
        currentDefaultPolicy.isDefault = false;
      }
    },
    resetList() {
      self.policyList = [];
    },
  }));

export default Policies;
